import ApiMethods from './ApiMethods';

export async function fetchSampleAnalysisStatus({ sampleId, accessToken }) {
    const analyses = await ApiMethods.get(
        `v1/lib_seqs/${sampleId}/analyses?primary_only=True&extra_fields=status`,
        accessToken
    );

    return analyses?.[0]?.attributes?.status || null;
}
